import { __assign } from "tslib";
/* I03 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var FollowingWatch = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { fillRule: "evenodd", d: "M12 4c-3.2981 0-6.322 2.1848-9.1496 6.2712L2 11.5l.8504 1.2288C5.678 16.8152 8.7019 19 12 19s6.322-2.1848 9.1496-6.2712L22 11.5l-.8504-1.2288C18.322 6.1848 15.2981 4 12 4zm0 2c2.7614 0 5 2.2386 5 5s-2.2386 5-5 5-5-2.2386-5-5 2.2386-5 5-5zm1 2l-2 2 2 2 2-2-2-2z" }))));
};
FollowingWatch.displayName = 'FollowingWatch';
export default FollowingWatch;
//# sourceMappingURL=FollowingWatch.js.map